import { render, staticRenderFns } from "./ui-test.vue?vue&type=template&id=833db086&scoped=true&"
import script from "./ui-test.vue?vue&type=script&lang=ts&"
export * from "./ui-test.vue?vue&type=script&lang=ts&"
import style0 from "./ui-test.vue?vue&type=style&index=0&id=833db086&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "833db086",
  null
  
)

export default component.exports